module.exports = "<main>\r\n  <router-outlet>\r\n    <app-spinner></app-spinner>\r\n  </router-outlet>\r\n</main>\r\n"